// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-wrapper[data-v-0f2c66a9]{gap:16px}.app-search[data-v-0f2c66a9]{position:relative}.app-search .app-search-input[data-v-0f2c66a9]{width:calc(100% - 40px)}#clearBtn[data-v-0f2c66a9]{position:absolute;top:50%;right:20px;transform:translateY(-50%)}", ""]);
// Exports
module.exports = exports;
